import React from 'react';
import styled from '@emotion/styled';
import calixLogoSrc from '@Calix-Commerce/design-system/assets/img/calix-logo.png';
import {
  Header as BaseHeader,
  HeaderContainer,
  HeaderTitle,
} from '@Calix-Commerce/design-system/components';

import { RepresentativeMenu, MainMenu } from './subcomponents';
import { Container } from '@Calix-Commerce/design-system/layout';
import { TimedBanner } from 'components/TimedBanner';

// Maintenance banner will be active from December 20th, 2025 through January 6th, 2026.
const MAINTENANCE_BANNER_DATES = {
  START: '2025-12-20T00:00:00.000-04:00',
  END: '2026-01-06T23:59:59.999-08:00',
};

const Title = styled(HeaderTitle)`
  font-size: 1.5rem;
`;

const Header = () => (
  <>
    <BaseHeader>
      <HeaderContainer>
        <img src={calixLogoSrc} alt="Calix Logo" />
        <Title>My Calix Store</Title>
        <RepresentativeMenu />
        <MainMenu />
      </HeaderContainer>
    </BaseHeader>
    <Container>
      <TimedBanner
        startDate={MAINTENANCE_BANNER_DATES.START}
        endDate={MAINTENANCE_BANNER_DATES.END}
        type="warning"
        fixed={false}
      >
        Our systems are undergoing annual maintenance January 1, 2026 through January 6, 2026.
        During this temporary period, there'll be limited functionality and delayed updates. If you
        have questions regarding order status please contact Calix Customer Operations (
        <a href={`mailto:calixcustomerops@calix.com`}>calixcustomerops@calix.com</a>), if you have
        questions regarding an RMA please contact Calix RMA team (
        <a href={`mailto:rma@calix.com`}>rma@calix.com</a>). Thank you for visiting the My Calix
        portal and we appreciate your patience!
      </TimedBanner>
    </Container>
  </>
);

export { Header };
